import {
  Ellipsis,
  GenericTable,
  GenericTableVariant,
} from "@visiblethread/react-components";
import { fileShape } from "components/Modal/ChooseFilesModal/propTypes";
import { getDocumentIcon } from "components/Modal/ChooseFilesModal/utils";
import { getStatusIcon } from "components/Modal/UploadFilesModal/utils";
import { arrayOf, shape } from "prop-types";
import { useSelector } from "react-redux";
import { selectfileUploadStates } from "slices/workspace/selectors";

import classes from "./FilesTable.module.scss";

const getColumns = (fileUploadStates) => [
  {
    header: "File Name",
    accessorKey: "name",
    id: "name",
    size: 332,
    minSize: 150,
    cell: ({ row }) => {
      const file = row.original;

      const currentState = fileUploadStates[file.hash] || {
        status: file.status,
        error: file.error,
      };
      return (
        <span className="upload_files_modal__table__file_name">
          {getDocumentIcon(file.content.name)}
          <Ellipsis text={file.content.name} />
          {getStatusIcon(currentState)}
        </span>
      );
    },
    sortingFn: (a, b) =>
      a.original.content.name.localeCompare(b.original.content.name, "en", {
        numeric: true,
        sensitivity: "base",
      }),
  },
  {
    header: "Source",
    accessorKey: "source",
    id: "source",
    size: 90,
    minSize: 90,
    cell: ({ row }) => {
      const file = row.original;
      return (
        <span className="upload_files_modal__table__file_source">
          <Ellipsis text={file.source} />
        </span>
      );
    },
    sortingFn: (a, b) => b.original.source.localeCompare(a.original.source),
    enableResizing: false,
  },
];

const FilesTable = ({ files }) => {
  const fileUploadStates = useSelector(selectfileUploadStates);

  return (
    <GenericTable
      className={classes.table}
      data={files}
      columns={getColumns(fileUploadStates)}
      loading={false}
      defaultSortColumnIndex={-1}
      rowIdKey="hash"
      selectedIndex={-1}
      rowClassName="upload_files_modal__generic_table__row"
      variant={GenericTableVariant.bordered}
    />
  );
};

FilesTable.propTypes = {
  files: arrayOf(shape(fileShape)).isRequired,
};

export default FilesTable;
